export const MIN_Y = 60;
export const MAX_Y = window.innerHeight - 90;
export const INITIAL_Y = MAX_Y * 0.6;
export const BOTTOM_SHEET_HEIGHT = window.innerHeight - MIN_Y;
